import { combineReducers } from 'redux';

import plannerUiReducer from './plannerUiReducer';
import plannerDataReducer from './plannerDataReducer';

export default combineReducers({
  ui: plannerUiReducer,
  data: plannerDataReducer,
});
